import robotSprite from "../../assets/pricing-robot.png";

// Fetch the sprite with the screen, not on the tap: the pop-in lasts ~0.5 s,
// a cold 128 kB image would land after it and Robo would blink in late.
if (typeof Image !== "undefined") new Image().src = robotSprite;

/** Six hand-drawn poses: think, scratch, then tap the handheld calculator. */
export function PricingRobot() {
  return (
    <div className="brief-calculating" role="status" aria-label="Calculating" aria-busy="true">
      {/* The pop lives on the wrapper so the sprite keeps its one animation. */}
      <span className="brief-robot-pop" aria-hidden="true">
        <div className="brief-robot" style={{ backgroundImage: `url(${robotSprite})` }} />
      </span>
      <div className="brief-calculating-word" aria-hidden="true">
        <span>crunching…</span>
        <span>calculussing…</span>
      </div>
    </div>
  );
}
